import React from "react";
import nextId from "react-id-generator";
import { Link, Redirect, Route, Switch } from "react-router-dom";
import { Images } from "../../Assets/0a-exporter";
import LoginComponent from "../Common/LoginComponent/LoginComponent";
import "./login-page.style.scss";
export default function LoginPage() {
  const [mainType, setMainType] = React.useState(options[0]);
  return (
    <section className="login-page-main">
      <aside className="login-page-left">
        <img className="dots-up" src={Images.topRightDots} />
        <img className="dots-bottom" src={Images.dotsLeftBottom} />
        <p className="bottom-text">
          <Link to="/contact">About AcadsHR - Contact US</Link>
        </p>
        <div className="l-p-f-header">
          <Link to="/">
          <img src={Images.mainLogo} alt="acads" />
          </Link>
        </div>
        <div className="l-p-f-title-info">
          <h5>You are the teacher of the world</h5>
          <p>Join us today and get recruited!</p>
        </div>
        <div className="l-p-f-pros">
          {info.map((obj) => (
            <div key={obj.keyId} className="l-p-f-row">
              <img src={obj.icon} alt={obj.title} />
              <div>
                <h5>{obj.title}</h5>
                <p>{obj.para}</p>
              </div>
            </div>
          ))}
        </div>
      </aside>
      <div className="login-page-right">
        <div className="l-p-r-header">
          <p>
            Don't have an account?
            <Link to={`/sign-up/${mainType.id}`}> Sign up</Link>
          </p>
        </div>
        <div className="l-p-r-body-wrapper">
          <Switch>
            <Route
              path="/login/:loginType"
              render={() => <LoginComponent setMainType={setMainType} />}
            />
            <Redirect to="/login/candidate" />
          </Switch>
        </div>
      </div>
    </section>
  );
}
const info = [
  {
    keyId: nextId(),
    icon: Images.grayWatch,
    title: "Your time is valuable",
    para: "You can search for Teacher Jobs using our simple Mobile App. Use it at your convenience, no matter where you are.",
  },
  {
    keyId: nextId(),
    icon: Images.graySuitcase,
    title: "Get recruited by top institutes",
    para: "Our Mobile App notifies you the recommended Jobs as per your preference. Apply wisely to get recruited",
  },
  {
    keyId: nextId(),
    icon: Images.grayHand,
    title: "Obtain career guidance",
    para: "Join us to build your CV and profile.",
  },
];

const options = [
  { keyId: nextId(), id: "candidate", text: "For Candidates" },
  { keyId: nextId(), id: "institution", text: "For Institutes" },
];
